/* TEENWEAR cart page: AJAX quantity/remove controller with discount fallback. */
(function () {
  'use strict';

  if (window.__twCartPageAjaxControllerInstalled) return;
  window.__twCartPageAjaxControllerInstalled = true;

  var busy = false;

  function cartPage() {
    return document.querySelector('[data-tw-cart-page]');
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartRoute() {
    return (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart) || (shopRoot() + 'cart');
  }

  function addonId(root) {
    return root ? (parseInt(root.getAttribute('data-addon-variant-id'), 10) || 0) : 0;
  }

  function fetchCart() {
    return fetch(shopRoot() + 'cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function postJSON(path, body) {
    return fetch(shopRoot() + path, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (error) {}
        return { ok: response.ok, status: response.status, data: data };
      });
    });
  }

  function validResult(result) {
    return !!(
      result &&
      result.ok &&
      (!result.data || (
        !result.data.errors &&
        !result.data.error &&
        result.data.status !== 422
      ))
    );
  }

  function activeCodes(cart) {
    return (cart && cart.discount_codes ? cart.discount_codes : []).filter(function (discount) {
      return discount && discount.code &&
        discount.applied !== false &&
        discount.applicable !== false;
    }).map(function (discount) {
      return String(discount.code);
    });
  }

  function sameCodes(leftCodes, rightCodes) {
    if (leftCodes.length !== rightCodes.length) return false;

    var left = leftCodes.map(function (code) { return code.toUpperCase(); }).sort();
    var right = rightCodes.map(function (code) { return code.toUpperCase(); }).sort();

    return left.every(function (code, index) {
      return code === right[index];
    });
  }

  function setCodes(codes) {
    return postJSON('cart/update.js', { discount: codes.join(',') }).then(function (result) {
      if (!validResult(result)) throw new Error('Discount update failed');
      return fetchCart();
    });
  }

  function changeLine(line, quantity) {
    return postJSON('cart/change.js', {
      line: Number(line),
      quantity: Number(quantity)
    });
  }

  function restoreValidCodes(savedCodes) {
    if (!savedCodes.length) return fetchCart();

    return setCodes(savedCodes).then(function (cart) {
      var validCodes = activeCodes(cart);
      if (sameCodes(validCodes, savedCodes)) return cart;
      return setCodes(validCodes);
    }).catch(function () {
      return setCodes([]).catch(fetchCart);
    });
  }

  function removeOrphanAddon(cart) {
    var root = cartPage();
    var id = addonId(root);
    if (!id || !cart || !cart.items) return Promise.resolve(cart);

    var hasRealItem = cart.items.some(function (item) {
      return Number(item.variant_id) !== id;
    });
    var hasAddon = cart.items.some(function (item) {
      return Number(item.variant_id) === id;
    });

    if (hasRealItem || !hasAddon) return Promise.resolve(cart);

    return postJSON('cart/change.js', {
      id: String(id),
      quantity: 0
    }).then(function (result) {
      if (!validResult(result)) throw new Error('Add-on cleanup failed');
      return fetchCart();
    });
  }

  function copyInnerHTML(currentRoot, incomingRoot, selector) {
    var current = currentRoot.querySelector(selector);
    var incoming = incomingRoot.querySelector(selector);
    if (current && incoming) current.innerHTML = incoming.innerHTML;
  }

  function syncRecommendations(currentRoot, incomingRoot) {
    var current = currentRoot.querySelector('.tw-cart-page__recs');
    var incoming = incomingRoot.querySelector('.tw-cart-page__recs');

    if (current && incoming) {
      current.replaceWith(document.importNode(incoming, true));
      return;
    }

    if (current && !incoming) {
      current.remove();
      return;
    }

    if (!current && incoming) {
      var items = currentRoot.querySelector('[data-minimog-cart-items]');
      if (items) items.insertAdjacentElement('afterend', document.importNode(incoming, true));
    }
  }

  function realItemCount(cart, id) {
    return (cart && cart.items ? cart.items : []).reduce(function (count, item) {
      return count + (Number(item.variant_id) === id ? 0 : Number(item.quantity || 0));
    }, 0);
  }

  function syncVisibleState(cart) {
    var root = cartPage();
    if (!root) return;

    var id = addonId(root);
    var count = realItemCount(cart, id);
    var addonOn = (cart.items || []).some(function (item) {
      return Number(item.variant_id) === id;
    });

    root.classList.toggle('m-cart--empty', count === 0);
    var minimogCart = root.querySelector('m-cart');
    if (minimogCart) minimogCart.classList.toggle('m-cart--empty', count === 0);

    root.querySelectorAll('[data-tw-page-count]').forEach(function (element) {
      element.textContent = count;
    });

    root.querySelectorAll('[data-tw-page-addon]').forEach(function (box) {
      box.classList.toggle('is-on', addonOn);
      box.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.checked = addonOn;
        input.setAttribute('aria-checked', addonOn ? 'true' : 'false');
      });
    });

    document.querySelectorAll('.m-cart-count-bubble,.m-cart-count').forEach(function (element) {
      element.textContent = count;
      element.classList.toggle('m:hidden', count === 0);
    });

    document.querySelectorAll('.m-cart-icon-bubble').forEach(function (element) {
      element.setAttribute('aria-label', String(count));
    });
  }

  function refreshPageSections(cart) {
    var url = new URL(cartRoute(), window.location.origin);
    url.searchParams.set('section_id', 'cart-template');
    url.searchParams.set('_tw', String(Date.now()));

    return fetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart section request failed');
      return response.text();
    }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var currentRoot = cartPage();
      var incomingRoot = parsed.querySelector('[data-tw-cart-page]');
      if (!currentRoot || !incomingRoot) throw new Error('Cart section is missing');

      copyInnerHTML(currentRoot, incomingRoot, '[data-minimog-cart-items]');
      copyInnerHTML(currentRoot, incomingRoot, '[data-cart-subtotal]');
      copyInnerHTML(currentRoot, incomingRoot, '[data-minimog-cart-discounts]');
      copyInnerHTML(currentRoot, incomingRoot, '[data-minimog-gift-wrapping]');
      syncRecommendations(currentRoot, incomingRoot);
      syncVisibleState(cart);

      if (window.MinimogEvents && window.MinimogTheme) {
        var events = window.MinimogTheme.pubSubEvents || {};
        if (events.cartUpdate) {
          window.MinimogEvents.emit(events.cartUpdate, Object.assign({}, cart, {
            source: 'main-cart-items'
          }));
        }
      }

      window.requestAnimationFrame(function () {
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function setLoading(element, loading) {
    var target = element && (element.closest('m-quantity-input') || element);
    if (!target) return;

    target.style.opacity = loading ? '.45' : '';
    target.style.pointerEvents = loading ? 'none' : '';
    if (loading) target.setAttribute('aria-busy', 'true');
    else target.removeAttribute('aria-busy');
  }

  function mutateLine(line, quantity, element) {
    if (busy || !line) return;

    busy = true;
    setLoading(element, true);
    var savedCodes = [];

    fetchCart()
      .then(function (cart) {
        savedCodes = activeCodes(cart);
        return changeLine(line, quantity);
      })
      .then(function (result) {
        if (validResult(result)) {
          return fetchCart().then(function (cart) {
            var validCodes = activeCodes(cart);
            if (!sameCodes(validCodes, savedCodes)) return setCodes(validCodes);
            return cart;
          });
        }

        if (!savedCodes.length) throw new Error('Cart line change failed');

        return setCodes([])
          .then(function () { return changeLine(line, quantity); })
          .then(function (retryResult) {
            if (!validResult(retryResult)) throw new Error('Cart line retry failed');
            return restoreValidCodes(savedCodes);
          });
      })
      .then(removeOrphanAddon)
      .then(function (cart) {
        return refreshPageSections(cart);
      })
      .catch(function () {
        return fetchCart()
          .then(function (cart) {
            syncVisibleState(cart);
          })
          .catch(function () {});
      })
      .finally(function () {
        busy = false;
        setLoading(element, false);
      });
  }

  function isInsideCartPage(element) {
    var root = cartPage();
    return !!(root && element && root.contains(element));
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var remove = event.target.closest('m-cart-remove-button');
    if (remove && isInsideCartPage(remove)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      mutateLine(parseInt(remove.getAttribute('data-index'), 10), 0, remove);
      return;
    }

    var button = event.target.closest('.tw-qty .m-quantity__button');
    if (!button || !isInsideCartPage(button)) return;

    var quantityInput = button.closest('m-quantity-input');
    var input = quantityInput && quantityInput.querySelector('.m-quantity__input');
    if (!input) return;

    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = parseInt(input.getAttribute('min'), 10) || 1;

    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var next = button.getAttribute('name') === 'plus' ? current + step : current - step;
    var min = parseInt(input.getAttribute('min'), 10);
    var max = parseInt(input.getAttribute('max'), 10);

    if (!isNaN(min) && next < min) return;
    if (!isNaN(max) && next > max) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    input.value = next;
    mutateLine(parseInt(input.getAttribute('data-index'), 10), next, quantityInput);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches ||
        !input.matches('.m-quantity__input') ||
        !isInsideCartPage(input)) return;

    var quantity = parseInt(input.value, 10);
    var min = parseInt(input.getAttribute('min'), 10);
    var max = parseInt(input.getAttribute('max'), 10);

    if (isNaN(quantity)) quantity = !isNaN(min) ? min : 1;
    if (!isNaN(min) && quantity < min) quantity = min;
    if (!isNaN(max) && quantity > max) quantity = max;
    input.value = quantity;

    event.preventDefault();
    event.stopImmediatePropagation();
    mutateLine(
      parseInt(input.getAttribute('data-index'), 10),
      quantity,
      input.closest('m-quantity-input') || input
    );
  }, true);
})();
